import { toast } from "react-toastify";
import ModalWrapper from "../../ModalWrapper";
import { useState } from "react";
import { FaStar } from "react-icons/fa";
import { rateNaray8 } from "../../../redux/naray8/naray8Action";
import SuccessModal from "../../ModalComponents/SuccessModal";
import { useQueryClient } from "@tanstack/react-query";

const RatingModal = ({ narrateId, isOpen, onClose, onSubmit, currentRating, title }) => {
    const [rating, setRating] = useState(currentRating || 0);
    const [hoverRating, setHoverRating] = useState(0);
    const [submitting, setSubmitting] = useState(false);
    const [showSuccess, setShowSuccess] = useState(false);

    const queryClient = useQueryClient();

    if (!isOpen) return null;

    const handleSubmit = async () => {
        try {
            if (rating === 0) {
                toast.error("Please select a rating before submitting");
                return;
            }

            setSubmitting(true);

            await rateNaray8(narrateId, rating);

            // ✅ Refresh all related queries
            queryClient.invalidateQueries({ queryKey: ["naray8", narrateId] });
            queryClient.invalidateQueries({ queryKey: ["naray8-story"] });
            queryClient.invalidateQueries({ queryKey: ["naray8-writer"] });

            setRating(0);
            setShowSuccess(true);
            
        } catch (error) {
            toast.error(error.message || "Something went wrong! try again later");
        } finally {
            setSubmitting(false);
        }
    };

    // ✅ Handle success modal close with parent refresh
    const handleSuccessClose = () => {
        setShowSuccess(false);
        onClose?.(); // This will trigger parent's refetch
    };

    if (showSuccess) {
        return (
            <SuccessModal
                onClose={handleSuccessClose}
                message="Rating submitted!"
            />
        );
    }

    return (
        <ModalWrapper
            title="Rate this book"
            subTitleSection={<p className="text-sm text-gray-300">{title}</p>}
            disableHeaderBorder
            onClose={onClose}
        >
            <div className="p-6">
                <div className="flex justify-center gap-2 mb-6">
                    {[1, 2, 3, 4, 5].map((star) => (
                        <button
                            key={star}
                            onMouseEnter={() => setHoverRating(star)}
                            onMouseLeave={() => setHoverRating(0)}
                            onClick={() => setRating(star)}
                            className="focus:outline-none transition-transform hover:scale-110"
                        >
                            <FaStar
                                size={40}
                                className={`${
                                    (hoverRating || rating) >= star
                                        ? "text-customGold"
                                        : "text-gray-500"
                                } transition-colors`}
                            />
                        </button>
                    ))}
                </div>

                <div className="text-center mb-6">
                    <p className="text-sm text-gray-300">
                        {rating === 1 && "Poor"}
                        {rating === 2 && "Fair"}
                        {rating === 3 && "Good"}
                        {rating === 4 && "Very Good"}
                        {rating === 5 && "Excellent"}
                        {rating === 0 && "Select a rating"}
                    </p>
                </div>

                <div className="flex gap-3">
                    <button
                        onClick={onClose}
                        className="flex-1 px-4 py-2 rounded-[5px] bg-customDark hover:bg-gray-700 text-white transition-colors"
                    >
                        Cancel
                    </button>

                    <button
                        onClick={handleSubmit}
                        disabled={submitting || rating === 0}
                        className="flex-1 px-4 py-2 rounded-[5px] bg-customGold text-black hover:bg-[#D4A520] transition-colors disabled:opacity-50"
                    >
                        {submitting ? "Submitting..." : "Submit Rating"}
                    </button>
                </div>
            </div>
        </ModalWrapper>
    );
};

export default RatingModal;